import {HttpStatus} from "../../../infrastructure/http-status";

export const editFailedText = "Editing configuration failed.";
export const editSuccessText = "Configuration edited.";
export const configurationLoadErrorText = "Failed to load a configuration";
export const noAccessText = "You do not have access to Mobile Service";
export const idNotFoundText = "Configuration's ID was not found";
export const statusToErrorText = {
  [HttpStatus.Forbidden]: noAccessText,
  [HttpStatus.NotFound]: idNotFoundText
};
